import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { Observable, of, timer } from 'rxjs'
import { catchError, first, map, switchMap } from 'rxjs/operators'
import { TemplateService } from '../services/template.service'
import { GlobalErrorService } from '@services/global-error.service'

export function templateConditionExistsValidator(
  templateService: TemplateService,
  globalErrorService: GlobalErrorService,
  initialCategory: string | null = null,
  initialCoverage: string | null = null
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const cert = control.get('certificateCategory')?.value as string | null
    const coverage = control.get('coverageType')?.value as string | null

    if (cert === null || cert === undefined || cert === '' ||
      coverage === null || coverage === undefined || coverage === '') {
      return of(null)
    }

    if (initialCategory !== null && initialCoverage !== null &&
      cert === initialCategory && coverage === initialCoverage) {
      return of(null)
    }

    return timer(300).pipe(
      switchMap(() => templateService.checkConditionExists(cert, coverage)),
      map(exists => (exists ? { conditionExists: true } : null)),
      catchError(() => {
        globalErrorService.reportError({
          subsystemName: 'Template Condition Validator',
          description: 'Could not validate if template condition combination exists. Please try again.'
        })
        return of(null)
      }),
      first()
    )
  }
}
